import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import SwipeableViews from "react-swipeable-views";

// material-ui components
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { GridProps } from "@material-ui/core/Grid";

import styles from "assets/jss/elite-feats-cms/components/navPillsStyle";
import { Events } from "react-scroll";

const useStyles = makeStyles(styles);

interface NavPillsTab {
  tabButton?: string;
  tabIcon?: React.ComponentType<{ className?: string }>;
  tabContent?: React.ReactNode;
}

interface NavPillsProps {
  active?: number;
  tabs: NavPillsTab[];
  color?: "primary" | "warning" | "danger" | "success" | "info" | "rose" | "black";
  direction?: string;
  horizontal?: { tabsGrid?: Partial<GridProps>; contentGrid?: Partial<GridProps> };
  alignCenter?: boolean;
  setPageChanged: (active: number) => void;
  reload?: unknown;
  reloadTimeline?: unknown;
  updateHeight: (active: number) => void;
  startTour?: number;
}

export default function NavPills(props: NavPillsProps): React.ReactElement {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [active, setActive] = React.useState(props.active);
  const [height, setHeight] = React.useState(false);
  const [reload, setReload] = React.useState(Math.random());

  const viewRef = React.useRef<SwipeableViews>(null);
  const handleChange = (event: React.ChangeEvent<{}>, active: number) => {
    props.setPageChanged(active);
    setActive(active);
  };
  const handleChangeIndex = (index: number) => {
    setActive(index);
  };
  const classes = useStyles();
  const { tabs, direction, color, horizontal, alignCenter } = props;
  const flexContainerClasses = classNames({
    [classes.flexContainer]: true,
    [classes.horizontalDisplay]: horizontal !== undefined,
  });

  const firstRender = React.useRef(true);
  React.useEffect(() => {
    if (!firstRender.current) {
      setHeight(true);
    }
    firstRender.current = false;
  }, [props.reload]);

  React.useEffect(() => {
    viewRef.current!.getChildContext().swipeableViews.slideUpdateHeight();
  }, [props.reloadTimeline]);

  React.useEffect(() => {
    props.updateHeight(active as number);
  }, [active]);

  const tabButtons = (
    <Tabs
      classes={{
        root: classes.root,
        fixed: classes.fixed,
        flexContainer: flexContainerClasses,
        indicator: classes.displayNone,
      }}
      value={active}
      onChange={handleChange}
      centered={alignCenter}
      style={{ marginTop: 67 }}
    >
      {tabs.map((prop, key) => {
        const icon: { icon?: React.ReactElement } = {};
        if (prop.tabIcon !== undefined) {
          icon["icon"] = <prop.tabIcon className={classes.tabIcon} />;
        }
        const pillsClasses = classNames({
          [classes.pills]: true,
          [classes.horizontalPills]: horizontal !== undefined,
          [classes.pillsWithIcons]: prop.tabIcon !== undefined,
        });
        return (
          <Tab
            className={`account-activity-${key}`}
            label={prop.tabButton}
            key={key}
            {...icon}
            classes={{
              root: pillsClasses,
              selected: classes[color as string],
            }}
            /* style={{
              border: "1px dashed #c0c0c0",
            }} */
          />
        );
      })}
    </Tabs>
  );
  const tabContent = (
    <div className={classes.contentWrapper + " " + "full-activity"}>
      <SwipeableViews
        ref={viewRef}
        axis={direction === "rtl" ? "x-reverse" : "x"}
        index={active}
        onChangeIndex={handleChangeIndex}
        style={{ overflowY: "hidden" }}
        containerStyle={{
          display: props.startTour === 1 ? "block" : "flex",
          transition: "transform 0.35s cubic-bezier(0.15, 0.3, 0.25, 1) 0s",
        }}
        animateHeight={height}
      >
        {tabs.map((prop, key) => {
          return (
            <div className={classes.tabContent} key={key}>
              {prop.tabContent}
            </div>
          );
        })}
      </SwipeableViews>
    </div>
  );
  return horizontal !== undefined ? (
    <GridContainer>
      <GridItem {...horizontal.tabsGrid}>
        <div style={{ minHeight: isMobile ? "auto" : "calc(100vh - 130px)" }}>{tabButtons}</div>
      </GridItem>

      <GridItem {...horizontal.contentGrid}>
        <div
          style={{
            minHeight: isMobile ? "auto" : "calc(100vh - 130px)",
          }}
        >
          {tabContent}
        </div>
      </GridItem>
    </GridContainer>
  ) : (
    <div>
      {tabButtons}
      {tabContent}
    </div>
  );
}

NavPills.defaultProps = {
  active: 0,
  color: "primary",
};

